import React from "react";
import { useNavigate } from 'react-router-dom';
import { Block } from 'baseui/block';
import {
    LabelLarge,
    LabelSmall,
    ParagraphSmall,
    ParagraphXSmall
} from 'baseui/typography';
import { ListItem, ListItemLabel } from 'baseui/list';
import { Button, KIND, SIZE, SHAPE, ButtonProps } from 'baseui/button';
import { useStyletron } from 'baseui';
import { Check, ChevronRight } from 'baseui/icon';
import { IoTrashOutline, IoLinkOutline } from 'react-icons/io5'
//
import { LoadingView } from "../../../components";
// api
import { BacnetObjectTypes, BacnetPropertyIds, BacnetPropertyMappingConfiguration, useGetPropertyMappingsFromObjectIdQuery } from "../../../services/mapping/bacnet";
import { DeletePropertyMappingButton } from "./BacnetPropertyMappingDeleteButton";
import { VscArrowLeft, VscArrowRight } from "react-icons/vsc";


export const BacnetPropertyMappingsView = (props: { objectId: string, resourceGroupId: string }) => {
    const [css] = useStyletron();
    const { data, isLoading, isSuccess, error } = useGetPropertyMappingsFromObjectIdQuery(props.objectId);

    const navigate = useNavigate();

    function nav(url: string) {
        navigate(url);
    }

    return <>

        <ParagraphSmall>Mappings to convert BACnet property to object property</ParagraphSmall>
        <LoadingView isLoading={isLoading} isSucess={isSuccess} error={error}>
            <ul className={css({
                width: 'auto',
                paddingLeft: 0,
                paddingRight: 0
            })}>
                {data?.map((item: any, index: number) =>
                    <ListItem artwork={IoLinkOutline} key={item.id} endEnhancer={() => (
                        <>
                            <DeletePropertyMappingButton mappingId={item.id} name={item.id}></DeletePropertyMappingButton>
                            <Button onClick={() => nav(`/edgedevices/${item.deviceId}/${item.bacnetDeviceId}/${item.moduleId}?resourceGroupId=${props.resourceGroupId}`)} size="compact" kind="tertiary" shape="pill">
                                <ChevronRight size='scale1000' />
                            </Button>
                        </>
                    )}>
                        <ListItemLabel description={<PropertyDescription {...item}></PropertyDescription>} >{<PropertyHeader {...item} />}</ListItemLabel>
                    </ListItem>)}
            </ul>
        </LoadingView></>;
}

const PropertyDescription = (props: any) => {
    return (
        <>
            <span><code>{props.deviceId}/{props.moduleId}</code></span>
            {props.mapper &&
                    <ParagraphXSmall margin={0}>
                        {props.mapper.type?.replace("AutomationApps.Mappings.BACnet.PropertyMappers.", "")}
                        {props.mapper.parameters && <><span> </span> {JSON.stringify(props.mapper.parameters)}</>}
                    </ParagraphXSmall>
                }
        </>
    );
}

const PropertyHeader = (props: BacnetPropertyMappingConfiguration) => {
    return (
        <>
            <span>{props.propertyName} </span>
            <VscArrowRight></VscArrowRight>
            <span> DeviceId: '{props.bacnetDeviceId}'</span><span> {BacnetObjectTypes[props.bacnetObjectType]}:{props.bacnetObjectInstanceId}:{BacnetPropertyIds[props.bacnetPropertyType]}
            </span>
        </>
    );
}
